/** HTMLエスケープ：innerHTMLへ差し込む動的文字列は必ずこれを通す（XSS対策） */
export function esc(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
